import { Injectable, Injector } from '@angular/core';
import { SdkBase } from '../utilities/sdk-base/sdk.base';
import { map, Observable } from 'rxjs';
import { ODataRequest } from '../utilities/sdk-base/o-data-request';
import { CustodianResource } from '../models/resource/custodian.resource';
import { CustodianResourceToCustodianMapper } from '../models/mappers/custodian-resource-to-custodian.mapper';
import { Collection } from '../models/ui/collection.model';
import { Custodian } from '../models/ui/custodian.model';

@Injectable({ providedIn: 'root' })
export class CustodianSdk extends SdkBase {
	constructor(injector: Injector) {
		super(injector);
	}

	public get(): Observable<Collection<Custodian>> {
		const request = new ODataRequest('get', 'custodians/include-unassigned');
		return this.makeODataRequest$<CustodianResource[]>(request, 'api2').pipe(
			map((response) => {
				const mapper = new CustodianResourceToCustodianMapper();
				const values = mapper.mapCollection(response);
				return new Collection<Custodian>({
					items: values
				})
			})
		);
	}
}


